var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isDisplayAdd
      ? _c(
          "button",
          {
            staticClass: "btn action-btn btn--darkblue",
            on: { click: _vm.add },
          },
          [_vm._v(_vm._s(_vm.$t("action.add")))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isDisplayEdit
      ? _c(
          "button",
          {
            staticClass: "btn action-btn btn--orange",
            attrs: { disabled: _vm.disableEdit },
            on: { click: _vm.edit },
          },
          [_vm._v(_vm._s(_vm.$t("action.edit")))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isDisplayCancel
      ? _c(
          "button",
          {
            staticClass: "btn action-btn btn--darkblue",
            on: { click: _vm.cancel },
          },
          [_vm._v(_vm._s(_vm.$t("action.cancel")))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isDisplaySave
      ? _c(
          "button",
          {
            staticClass: "btn action-btn btn--orange",
            on: { click: _vm.save },
          },
          [_vm._v(_vm._s(_vm.$t("action.save")))]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }